export const Arrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="10"
    viewBox="0 0 8 10"
    fill="none"
  >
    <path
      d="M0.000107502 1.53576C0.000107382 0.765962 0.833441 0.284836 1.50011 0.669737L7.50011 4.13384C8.16677 4.51874 8.16677 5.48099 7.50011 5.86589L1.50011 9.32999C0.833441 9.71489 0.000107834 9.23377 0.000107697 8.46396L0.000107502 1.53576Z"
      fill="#B3B3B3"
    />
  </svg>
);
